import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  AddItem: {
    id: 'label_add_item',
    defaultMessage: 'Add item',
  },
  Actions: {
    id: 'label_actions',
    defaultMessage: 'Actions',
  },
  Icon: {
    id: 'label_icon',
    defaultMessage: 'Icon',
  },
  IconAfterLabel: {
    id: 'label_icon_after',
    defaultMessage: 'Icon after label',
  },
  Label: {
    id: 'label_label',
    defaultMessage: 'Label',
  },
  Title: {
    id: 'label_title',
    defaultMessage: 'Title',
  },
  OpenInNewTab: {
    id: 'label_new_tab',
    defaultMessage: 'Open in new tab',
  },
  URL: {
    id: 'label_url',
    defaultMessage: 'URL',
  },
  Type: {
    id: 'label_type',
    defaultMessage: 'Type',
  },
});

export const ButtonSchema = (props) => ({
  addMessage: props.intl.formatMessage(messages.AddItem),
  conditions: {
    icon_after: {
      icon: true,
    },
  },
  fieldsets: [
    {
      fields: [
        'type',
        'label',
        'title',
        'url',
        'new_tab',
        'icon',
        'icon_after',
      ],
      id: 'default',
      title: '',
    },
  ],
  properties: {
    icon: {
      title: props.intl.formatMessage(messages.Icon),
      widgetOptions: {
        frontendOptions: {
          widget: 'icon_widget',
          widgetProps: {
            vocabulary: {
              '@id': '/@vocabularies/fhnw.vocabularies.icon',
            },
          },
        },
      },
    },
    icon_after: {
      title: props.intl.formatMessage(messages.IconAfterLabel),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    label: {
      required: true,
      title: props.intl.formatMessage(messages.Label),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    new_tab: {
      title: props.intl.formatMessage(messages.OpenInNewTab),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    title: {
      title: props.intl.formatMessage(messages.Title),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    type: {
      title: props.intl.formatMessage(messages.Type),
      widgetOptions: {
        frontendOptions: {
          widget: 'select',
          widgetProps: {
            vocabulary: {
              '@id': '/@vocabularies/fhnw.vocabularies.button_type',
            },
          },
        },
      },
    },
    url: {
      required: true,
      title: props.intl.formatMessage(messages.URL),
      widgetOptions: {
        frontendOptions: {
          widget: 'url',
        },
      },
    },
  },
  required: ['label', 'url'],
  title: props.intl.formatMessage(messages.Actions),
});
